import React, { useMemo } from "react";
import "./PrivacyPolicy.css";
import { useLocalContext } from "../../context/LocalContext";

const PrivacyPolicy = () => {
  const { webinfo = {} } = useLocalContext();

  const brand = useMemo(
    () => ({
      name: webinfo.name || "webantidigi.com",
      email: webinfo.email || "contact@webantidigi.com",
      phone: webinfo.phone || "+1 (000) 000-0000",
      phonecall: webinfo.phonecall || "+10000000000",
      address: webinfo.address || "United States",
    }),
    [webinfo]
  );

  const effectiveDate = useMemo(
    () =>
      new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    []
  );

  return (
    <section className="pp-about">
      <div className="pp-container">
        <header className="pp-header">
          <span className="pp-badge">Privacy Policy</span>
          <h1>Privacy and data use notice</h1>
          <p className="pp-intro">
            This policy explains what information {brand.name} collects, how it is
            used, and your rights under applicable U.S. privacy laws.
          </p>

          <div className="pp-meta">
            <div>
              <span>Company</span>
              <strong>{brand.name}</strong>
            </div>
            <div>
              <span>Last updated</span>
              <strong>{effectiveDate}</strong>
            </div>
          </div>
        </header>

        <article className="pp-content">
          <section>
            <h2>1. Information we collect</h2>
            <ul>
              <li>Contact and account details you provide</li>
              <li>Order/payment-related transaction information</li>
              <li>Technical and usage data (IP, browser, device, analytics)</li>
              <li>Support communications and service requests</li>
            </ul>
          </section>

          <section>
            <h2>2. How we use information</h2>
            <ul>
              <li>Operate and deliver our services</li>
              <li>Process orders and customer support requests</li>
              <li>Prevent fraud and protect platform security</li>
              <li>Comply with legal and contractual obligations</li>
            </ul>
          </section>

          <section>
            <h2>3. Data sharing</h2>
            <p>
              We do not sell personal data for money. We share data only with
              trusted providers needed for payments, hosting, analytics, support,
              and legal compliance.
            </p>
          </section>

          <section>
            <h2>4. U.S. privacy rights</h2>
            <p>
              Depending on your state, you may request access, correction,
              deletion, or details about personal data processing. Submit requests
              to <a href={`mailto:${brand.email}`}>{brand.email}</a>.
            </p>
          </section>

          <section>
            <h2>5. Contact</h2>
            <ul className="pp-contact">
              <li>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${brand.email}`}>{brand.email}</a>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                <a href={`tel:${brand.phonecall}`}>{brand.phone}</a>
              </li>
              <li>
                <strong>Address:</strong> {brand.address}
              </li>
            </ul>
          </section>
        </article>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
